import { Component } from 'solid-js';
import { ActionModal } from '../action-modal';
import { SuccessIcon } from '../../../../components';
import {isMobile} from '../../../../hooks/isMobile';

interface TransactionSentModalProps {
    onClose: () => void;
}

export const TransactionSentModal: Component<TransactionSentModalProps> = props => {
    return (
        <ActionModal
            headerTranslationKey="actionModal.transactionSent.header"
            textTranslationKey="actionModal.transactionSent.text"
            icon={<SuccessIcon size="m" />}
            onClose={() => props.onClose()}
            showButton={isMobile() ? 'close' : undefined}
            data-tc-transaction-sent-modal="true"
        />
    );
};
